import {
  Avatar,
  Box,
  Card,
  CardActionArea,
  CardContent,
  Container,
  Grid,
  LinearProgress,
  Typography,
  Button,
  Link,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import useDocData from "../../../Hooks/useDocData";
import InstagramIcon from "@mui/icons-material/Instagram";


const OurExperts = () => {
  const [ourArtists, setOurArtists] = useState([]);
  const mainData = useDocData();
  const artists = useMemo(() => mainData[0] || [], [mainData]);

  useEffect(() => {
    if (artists.length > 0) {
      const featuredIds = [22, 18, 1];
      const selected = featuredIds
        .map((id) => artists.find((artist) => artist.doc_id === id))
        .filter(Boolean);
      setOurArtists(selected);
    }
  }, [artists]);

  return (
    <Box
      sx={{
        bgcolor: "#99cced",
        color: "primary.main",
        py: 6,
        textAlign: "center",
      }}
    >
      <Container maxWidth="xl">
        {/* ---------- HEADER ---------- */}
        <Typography sx={{ mb: 1, fontWeight: 700 }} variant="h6">
          Meet the Artists
        </Typography>

        <Typography sx={{ mb: 6 }} variant="h5">
          Featuring creators from our{" "}
          <Link
            href="/explore/artist-alley"
            color="inherit"
            underline="always"
          >
            Artist Alley in Ottawa
          </Link>
        </Typography>

        {/* ---------- GRID ---------- */}
        {artists.length === 0 && <LinearProgress color="secondary" />}

        {artists.length > 0 && (
          <Grid container spacing={4} justifyContent="center">
            {ourArtists.map((artist) => (
              <Grid
                key={artist.doc_id}
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
              >
                <Card
                  sx={{
                    maxWidth: 320,
                    mx: "auto",
                    borderRadius: 3,
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: 10,
                      transform: "translateY(-4px)",
                    },
                  }}
                >
                  {/* Entire card links to Instagram */}
                  <CardActionArea
                    component="a"
                    href={`https://instagram.com/${artist.instagram}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <CardContent sx={{ textAlign: "center" }}>
                <Box
  sx={{
    position: "relative",
    width: 220,
    height: 220,
    mx: "auto",
    mb: 2,
    borderRadius: "50%",
    overflow: "hidden",
  }}
>
 <Box
  sx={{
    position: "relative",
    width: 220,
    height: 220,
    mx: "auto",
    mb: 2,
    borderRadius: "50%",
    overflow: "hidden",
  }}
>
  <Avatar
    alt={artist.name}
    src={artist.doc_img}
    imgProps={{ loading: "lazy", decoding: "async" }}
    sx={{
      width: "100%",
      height: "100%",
      transition: "transform 0.3s ease",
      ".MuiCardActionArea-root:hover &": {
        transform: "scale(1.05)",
      },
    }}
  />

  {/* Gradient + Instagram hover overlay */}
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background:
        "linear-gradient(135deg, rgba(88,81,219,0.6), rgba(193,53,132,0.6))",
      opacity: 0,
      transition: "opacity 0.25s ease",
      ".MuiCardActionArea-root:hover &": {
        opacity: 1,
      },
    }}
  >
    <InstagramIcon
      sx={{
        fontSize: 52,
        color: "#99cced",
        transform: "scale(0.8)",
        transition: "transform 0.25s ease",
        ".MuiCardActionArea-root:hover &": {
          transform: "scale(1)",
        },
      }}
    />
  </Box>
</Box>

  {/* Instagram hover overlay */}
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      bgcolor: "rgba(0,0,0,0.45)",
      opacity: 0,
      transition: "opacity 0.25s ease",
      ".MuiCardActionArea-root:hover &": {
        opacity: 1,
      },
    }}
  >
    <InstagramIcon
      sx={{
        fontSize: 48,
        color: "#fff",
      }}
    />
  </Box>
</Box>

                      <Typography
                        gutterBottom
                        variant="h6"
                        sx={{ fontWeight: 600 }}
                      >
                        {artist.name}
                      </Typography>

                      {artist.specialize && (
                        <Typography
                          variant="body2"
                          sx={{ color: "text.secondary" }}
                        >
                          {artist.specialize}
                        </Typography>
                      )}
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            ))}
          </Grid>
        )}

        {/* ---------- CTA ---------- */}
        <Box sx={{ mt: 6 }}>
          <Button
            variant="contained"
            size="large"
            href="/explore/artist-alley"
            sx={{
              borderRadius: 999,
              px: 5,
              py: 1.5,
              fontWeight: 600,
              textTransform: "none",
              boxShadow: 6,
            }}
          >
            Meet All Artists →
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default OurExperts;
